import React from 'react';
import {Link, Redirect} from 'react-router-dom';
import LeftMenu from './LeftMenu';
import RightContentHeader from './RightContentHeader';
import OverviewContainer from '../overview/OverviewContainer';
import VignetContainer from '../vignets/VignetContainer';
import VignetDetailContainer from '../vignets/DetailContainer';

import GraphicsContainer from '../gallery/GraphicsContainer';
import PlaylistContainer from '../playlist/PlaylistContainer';
import PlaylistDetailContainer from '../playlist/DetailContainer';
import UserContainer from '../user/UserContainer';
import FilterBar from "./FilterBar";
import PropTypes from 'prop-types';
import HeaderBar from "./HeaderBar";


import * as vignetsReducers from "../../reducers/vignets";
import * as playlistActions from "../../actions/playlist";
//import * as pageReducers from "../../reducers/pages";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as vignetsActions from "../../actions/vignets";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form , FormGroup, Label, Input, FormFeedback} from 'reactstrap';
//import {vignetService} from "../../services/vignets.services";
import * as playlistReducers from "../../reducers/playlist";
import $ from "jquery";




class MainLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value:'',
            showModal: false,
            showModal1: false,
            error_message:'',
            pl_name: '',
            userDet : JSON.parse(window.localStorage.userDet),
            wrapClass : 'right-bottom-area ',
            addVigToPl : false,
            detUrl : ''

        };

        this.toggle = this.toggle.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.renderContainer = this.renderContainer.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.savePlaylist = this.savePlaylist.bind(this);
    }

    componentDidMount() {
        if(this.props.pageName == 'PLAYLIST') {
            this.setState({
                wrapClass: 'right-bottom-area no-overflow'
            });
        }

        if( this.props.match.path === "/playlist/add/:id") {
            this.setState({ addVigToPl: true});
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if( prevProps.playlistData.playlistUpdated !== this.props.playlistData.playlistUpdated && this.props.match.path === "/playlist/add/:id") {
            this.setState({nextUrl : "/playlist/"+this.props.match.params.id });
        }



    }

    toggle() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    mToggle() {
        this.setState({
            showModal1: !this.state.showModal1
        });
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }



    renderContainer() {
        switch(this.props.pageName) {
            case 'OVERVIEW':
                return <OverviewContainer />;
            case 'VIGNETS':
                return <VignetContainer />;
            case 'VIGDETAIL':
                return <VignetDetailContainer />;
            case 'MY_UPLOADS':
                return <GraphicsContainer />;
            case 'AUDIO':
                return <GraphicsContainer />;
            case 'VIDEO':
                return <GraphicsContainer/>;
            case 'PLAYLIST':
                return <PlaylistContainer  showPlaylist={true} showVignets={false} showEdit={false}/>
            case 'PLAYLISTDETAIL':
                return <PlaylistDetailContainer />;
            case 'USER':
                return <UserContainer />;
            default:
                return <VignetContainer />;
        }
    }

    createPlayList() {

        let vigSelectCount = this.props.vignetsData.selected_ids.length;

        if(vigSelectCount === 0) {
            this.toggle();
            return false;
        }
        else {
            this.mToggle();
        }

    }

    savePlaylist() {
        let vigSelectCount = this.props.vignetsData.selected_ids.length;

        let error = '';

        if(vigSelectCount === 0) {
            error = "Select atleast a vignet to proceed";
        }
        else if(this.state.pl_name === '') {
            error = "Please enter  a playlist name to proceed";
        }
        else {
            error = "";
            var vigIds = this.props.vignetsData.selected_ids;

            var data = {pl_name : this.state.pl_name, vigIds: vigIds, userid : this.state.userDet.user_id};

            console.log(data);
            let created = this.props.createPlaylist(data);

            this.mToggle();

        }

        this.setState({error_message: error});
    }

    addToPlaylist() {
        console.log(this.props.playlistData);
        let data = {plid :  this.props.match.params.id , vigids : this.props.vignetsData.selected_ids}
        let added = this.props.addItemToPlaylist(data);

        // $("#plModal").({'data-dismiss': 'modal'});
    }


    render() {

        if(this.state.nextUrl){
            return <Redirect exact to={this.state.nextUrl} />
        }



        return (
            <div className="wrapper">
                <HeaderBar />
                <section className="content-area">
                    <div className="conten-wrapper">
                        <LeftMenu pageName={this.props.pageName} />

                        <div className="right-content-area">

                            <RightContentHeader pageName={this.props.pageName}  />

                            <div className={this.state.wrapClass}>
                                {this.props.pageName !== 'VIGDETAIL' && this.props.pageName !== 'OVERVIEW' && this.props.pageName !== 'PLAYLISTDETAIL'  &&
                                <FilterBar pageName={this.props.pageName}/>
                                }

                                {this.renderContainer()}
                                {this.props.pageName === 'PLAYLIST' && this.props.playlistData.newPlaylist &&
                                <button className="create-button" onClick={(e) => this.createPlayList()}></button>
                                }

                                <Modal isOpen={this.state.showModal} toggle={this.toggle} >
                                    <ModalBody>
                                        <div className="alert alert-danger text-center" role="alert">
                                            Please select atleast a vignet to proceed.
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="secondary" onClick={this.toggle}>Close</Button>
                                    </ModalFooter>
                                </Modal>


                                <Modal isOpen={this.state.showModal1} toggle={this.mToggle} centered={true} className="vig-mod">
                                    <ModalHeader className="vignet-header" toggle={this.mToggle}>Create Playlist</ModalHeader>
                                    <ModalBody>
                                        {this.state.error_message !== '' &&
                                        <div className="alert alert-danger hide" id="pl-error" role="alert">
                                            {this.state.error_message}
                                        </div>
                                        }
                                        <div className="form_container">


                                            <Form method="POST" >
                                                <FormGroup>
                                                    <Label for="exampleEmail">Enter Playlist Name</Label>
                                                    <Input type="text" name="pl_name" id="pl_name" placeholder="Playlist Name" className={this.state.pl_name_class} onChange={this.handleInputChange} valid={false} />
                                                    <FormFeedback className={this.state.pl_name_class}  tooltip> Please enter a playlist name</FormFeedback>
                                                </FormGroup>


                                            </Form>
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <FormGroup className="pull-right button-gp">
                                            <Button name="submit_form" type="button" color="info" className="save_btn" onClick={()=> this.savePlaylist()}>Save</Button>
                                            <Button name="build_vignet" type="button" color="success" onClick={this.mToggle}>Cancel</Button>
                                        </FormGroup>
                                    </ModalFooter>
                                </Modal>
                            </div>
                            {this.state.addVigToPl &&
                            <div className="pl-msg-wrap">
                                <div className="pl-msg-l">
                                    <span className="pl-msg">Start adding Vignets to New Playlist</span>
                                    <span className="pl-msg">Selected Vignets: {this.props.vignetsData? this.props.vignetsData.selected_ids.length: 0}</span>
                                </div>
                                <div className="pl-msg-r">
                                    <button name="done_btn" className="btn" onClick={() => {this.addToPlaylist()}}>DONE</button>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

MainLayout.propTypes = {
    getSelectedIds: PropTypes.func,
    pageName : PropTypes.string
}

function mapStateToProps(state) {
    return {
        vignetsData  :vignetsReducers.getVignetsData(state),
        playlistData  :playlistReducers.getPlaylistData(state)
    };

}

export default  withRouter(connect(mapStateToProps, {
    removeVignets : vignetsActions.deleteVignets,
    createPlaylist : playlistActions.createPlaylist,
    addItemToPlaylist : playlistActions.addToPlaylist
})(MainLayout, PlaylistContainer));



// WEBPACK FOOTER //
// ./src/components/common/MainLayout.js